<template>
  <div>
    <b-button-toolbar class="mb-3">
      <b-button 
        class="mr-3" 
        @click="getMedia()"
      >
        <i class="fa fa-refresh" /> verversen
      </b-button>
      <slot />
      <upload-file
        v-if="uploadfolder"
        :folder="uploadfolder"
        cloud="tranpslan"
        preset="hxdb54hj"
        @file-uploaded="fotos.unshift($event)"
      />
    </b-button-toolbar>
    <b-card-group columns>
      <b-card 
        v-for="(foto,index) in fotos" 
        :key="index" 
        no-body 
        class="mb-3"
      >
        <b-img 
          :src="foto.secure_url" 
          class="card-img-top"
        />
        <b-card-body>
          <b-button-toolbar class="icon pull-right">
            <b-button
              size="sm"
              class="mx-2"
              variant="danger"
              @click="deleteMedia(foto.public_id)"
            >
              <i class="fa fa-trash" />
            </b-button>

            <b-button 
              size="sm" 
              @click="$emit('foto-select',foto);"
            >
              <i class="fa fa-plus" />
            </b-button>
          </b-button-toolbar>
          {{ foto.created_at | formatDateTime }}
          <br>
          <small>{{ foto.public_id.substring(0,30)+".." }}</small>
        </b-card-body>
      </b-card>
    </b-card-group>
  </div>
</template>
<script>
import { mediaMixin } from "@/mixins/mediaMixin";
import UploadFile from "@/components/UploadFile"; // directe upload naar cloudinary

export default {
  name: "MediaGrid",
  components: {
    UploadFile
  },
  mixins: [ mediaMixin ],
  mounted() {
    this.getMedia();
  }
};
</script>